import produce from 'immer'
import { baseReportUrl } from 'environments'
import { createActions, normalizeDateRange } from 'helpers/actions'
import entityNames from 'options/entityNames'

export default createActions(entityNames.inventoryMinMaxReport, {
  basePath: 'report/inventoryReports',
  baseUrl: baseReportUrl,
  transformGetItemsParams: (params = {}) =>
    produce(params, (draft) => {
      draft.locationVendingTypes = ['NonVending']

      draft.shipDaysCalculation = draft.shipDaysCalculation || 'ByOrderDateReceived'

      normalizeDateRange(draft)
    }),
})
